import React, {useState} from 'react'

import {media} from 'styled-bootstrap-grid'
import styled from 'styled-components'

import {PagoLoanCalculation, PagoLoanOptions} from '@festi/common/api/rest'
import {MainButton} from '@festi/common/components/buttons'
import {styledTheme} from '@festi/common/themes'

import PagoPayLaterOption from './PagoPayLaterOption'
import PagoInstallmentsOption from './pagoInstallmentsOption'
import PagoRegistration from './pagoRegistration'

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${media.md`
    gap: 24px;
  `}
`

const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  padding-top: 8px;

  ${media.md`
    padding-top: 16px;
  `}
`

const ContentContainer = styled.div`
  position: relative;
  width: 100%;
`

// We hide the tabs until we start using the "pay later" option
const hide = true

interface PagoPaymentOptionsTabsProps {
  loanCalculationData: PagoLoanCalculation
  isLoading: boolean
  loanInstallments: number
  setLoanInstallments: (loanInstallments: number) => void
  installmentsOptions: PagoLoanOptions
  inCheckout?: boolean
}

export default function PagoPaymentOptionsTabs({
  loanCalculationData,
  isLoading,
  loanInstallments,
  setLoanInstallments,
  installmentsOptions,
  inCheckout,
}: PagoPaymentOptionsTabsProps) {
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <Root>
      {!hide && (
        <ButtonWrapper>
          <MainButton
            label="Greiðsludreifing"
            onClick={() => {
              setActiveIndex(0)
            }}
            buttonVariant="ghost"
            fullWidth
            style={{
              border:
                activeIndex === 0 &&
                `2px solid ${styledTheme.palette.lightBlue}`,
            }}
          />
          <MainButton
            label="14 daga greiðslufrestur"
            onClick={() => {
              setActiveIndex(1)
            }}
            buttonVariant="ghost"
            fullWidth
            style={{
              border:
                activeIndex === 1 &&
                `2px solid ${styledTheme.palette.lightBlue}`,
            }}
          />
        </ButtonWrapper>
      )}
      <ContentContainer>
        {activeIndex === 0 ? (
          <PagoInstallmentsOption
            loanInstallments={loanInstallments}
            setLoanInstallments={setLoanInstallments}
            loanCalculationData={loanCalculationData}
            isLoading={isLoading}
            installmentsOptions={installmentsOptions}
            inCheckout={inCheckout}
          />
        ) : (
          <PagoPayLaterOption />
        )}

        <PagoRegistration />
      </ContentContainer>
    </Root>
  )
}
